import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class ExplosionAnimation extends Animation {
  constructor(explosion: PIXI.Sprite, width: number, height: number, alpha: number, onComp = () => { }) {
    super();
    new Tween.Tween(explosion)
      .to({ width, height, alpha }, 800)
      .easing(Tween.Easing.Linear.None)
      .onComplete(() => {
        if (alpha == 1) {
          explosion.alpha = 0;
        }
        setTimeout(() => {
          onComp()
        }, 20);
      })
      .start()
  }
}